import FormPagar from './FormPagar';
import { useState } from 'react';
import Recibo from '../Recibo';
import { useLocation, useNavigate } from 'react-router-dom';
import { buscarReciboPorParams } from './handlers';
import MuniSpinner from '../../components/MuniSpinner';

const Pagar = () => {
  const [recibo, setRecibo] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const numero_acta = searchParams.get('numero_de_acta');
  const dependencia = searchParams.get('dependencia');
  const documento_titular = searchParams.get('documento');
  
  if (!recibo && dependencia && dependencia.toUpperCase() === 'MVD') {
    // buscarReciboPorParams(numero_acta, dependencia, setRecibo, navigate);

    let numero_acta_autocomplete = dependencia + '-';
    if (numero_acta) {
      numero_acta_autocomplete += numero_acta;
    }

    return (
      <div className="container pt-5">
        <div className={'bg-white rounded p-2 ' + (!recibo ? ' offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1' : '')}>
          <div className="p-4">
            <h4>Pago voluntario {recibo ? 'recibo número ' + recibo?.numeroRecibo?.notacionStandard : null}</h4>
            <hr />
            {!recibo ? <FormPagar numero_acta_autocomplete={numero_acta_autocomplete} documento_titular_autocomplete={documento_titular} setRecibo={setRecibo} /> : <Recibo recibo={recibo} setRecibo={setRecibo} />}
          </div>
        </div>
      </div>
    );
  }

  if (!recibo && numero_acta && dependencia && dependencia.toUpperCase() !== 'MVD') {
    buscarReciboPorParams(numero_acta, dependencia, setRecibo, navigate);

    return (
      <div className="container pt-5">
        <div className={'bg-white rounded p-2 ' + (!recibo ? ' offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1' : '')}>
          <MuniSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className="container pt-5">
      <div className={'bg-white rounded p-2 ' + (!recibo || (recibo && recibo.is_espontaneo && recibo.is_espontaneo === 1) ? ' offset-md-2 offset-lg-3 col-sm-8 col-sm-10 col-md-8 col-lg-6 offset-sm-1' : '')}>
        <div className="p-4">
          <h4>Pago voluntario {recibo && !recibo.is_espontaneo && recibo.is_espontaneo !== 1 ? 'recibo número ' + recibo?.numeroRecibo?.notacionStandard : null}</h4>
          <hr />
          {!recibo ? <FormPagar setRecibo={setRecibo} /> : <Recibo recibo={recibo} setRecibo={setRecibo} />}
        </div>
      </div>
    </div>
  );
};

export default Pagar;
